module.exports = __webpack_public_path__ + "img/ESL_cover_image.6ee07908.jpg";